module.exports = __webpack_public_path__ + "img/base_activites_rando_courte.b14b44c8.svg";